namespace $.$$ {

	export class $rise_devtools_selector_overlay_files extends $.$rise_devtools_selector_overlay_files {

		@ $mol_mem
		rpc() {
			return $rise_rpc_ws.make({
				$: this.$,
				uri: ()=> this.rpc_uri(),
			})
		}

		@ $mol_mem
		api() {
			$mol_wire_solid()
			return this.rpc().api< any >()
		}

		rpc_uri() {
			const port = this.rpc_port()
			if( port ) {
				const uri = new URL( '/rise/rpc/', this.$.$mol_dom_context.location.href )
				uri.port = String( port )
				return uri.toString().replace( /^http/, 'ws' )
			}
			return new URL( '/rise/rpc/', this.$.$mol_dom_context.location.href ).toString().replace( /^http/, 'ws' )
		}

		content() {
			return [
				this.Actions(),
				... this.editor_opened() ? [ this.Editor() ] : [],
				... this.file_error() ? [ this.Error() ] : [],
			] as readonly $mol_view[]
		}

		actions_content() {
			return [
				this.Open_view_tree(),
				this.Open_view_ts(),
				this.Open_view_css_ts(),
				... this.editor_opened() ? [ this.Save_file() ] : [],
			] as readonly $mol_view[]
		}

		file_open_view_tree( event?: Event ) {
			return this.file_open_kind( 'view.tree', event )
		}

		file_open_view_ts( event?: Event ) {
			return this.file_open_kind( 'view.ts', event )
		}

		file_open_view_css_ts( event?: Event ) {
			return this.file_open_kind( 'view.css.ts', event )
		}

		file_open_kind( kind: 'view.tree' | 'view.ts' | 'view.css.ts', event?: Event ) {
			event?.preventDefault()
			event?.stopPropagation()

			this.file_error( '' )
			$mol_error_fence(
				()=> {
					const file = this.api().file_open( this.target_info(), kind ) as {
						path: string
						text: string
					}
					this.file_path( file.path )
					this.file_text( file.text )
					this.editor_opened( true )
					return null
				},
				error => {
					this.file_error( error?.message ?? String( error ) )
					return null
				},
			)

			this.dom_tree()
			return event ?? null
		}

		file_save( event?: Event ) {
			event?.preventDefault()
			event?.stopPropagation()

			this.file_error( '' )
			$mol_error_fence(
				()=> {
					this.api().file_save({
						path: this.file_path(),
						text: this.file_text(),
					})
					return null
				},
				error => {
					this.file_error( error?.message ?? String( error ) )
					return null
				},
			)

			this.dom_tree()
			return event ?? null
		}

	}

}
